<template>
  <div>
    <v-card flat>
      <v-data-table
        :headers="headers"
        :items="ubicaciones"
        hide-default-footer>
        <template v-slot:[`item.acciones`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="preEditar(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Borrar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="mostrarEditarUbicacion"
      width="650"
      persistent
      v-if="estaUbicacion">
      <editar-infraestructura-ubicacion
        :ubicacion-editar="estaUbicacion"
        v-on:editarUbicacion="editarUbicacion"
        v-on:cerrar="cerrarUbicacion">
      </editar-infraestructura-ubicacion>
    </v-dialog>
  </div>
</template>

<script>
import EditarInfraestructuraUbicacion from './Editar.vue';

export default {
  name: 'InfraestructuraUbicaciones',
  props: {
    ubicaciones: {
      type: Array,
      required: true,
    },
  },
  components: {
    EditarInfraestructuraUbicacion,
  },
  data() {
    return {
      mostrarEditarUbicacion: false,
      estaUbicacion: null,
      headers: [
        {
          text: 'Lat punto [A]',
          align: 'center',
          sortable: false,
          value: 'latitudPuntoA',
        },
        { text: 'Lgn punto [A]', align: 'center', value: 'longitudPuntoA' },
        { text: 'Lat punto [B]', align: 'center', value: 'latitudPuntoB' },
        { text: 'Lgn punto [B]', align: 'center', value: 'longitudPuntoB' },
        {
          text: '', align: 'end', width: '150', value: 'acciones',
        },
      ],
    };
  },
  methods: {
    preEditar(ubicacion) {
      this.estaUbicacion = ubicacion;
      this.mostrarEditarUbicacion = true;
    },
    editarUbicacion(ubicacionEditada) {
      const index = this.ubicaciones
        .findIndex((ubicacion) => ubicacion
              === this.estaUbicacion);
      if (index !== -1) {
        this.ubicaciones.splice(index, 1, ubicacionEditada);
      }
      this.cerrarUbicacion();
    },
    borrar(ubicacionBorrar) {
      const index = this.ubicaciones
        .findIndex((ubicacion) => ubicacion
              === ubicacionBorrar);
      if (index !== -1) {
        this.ubicaciones.splice(index, 1);
      }
    },
    cerrarUbicacion() {
      this.estaUbicacion = null;
      this.mostrarEditarUbicacion = false;
      this.mostrarBorrarUbicacion = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
